import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewContainerRef,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { DeclineReasonComponent } from '../decline-reason/decline-reason.component';
import { BalanceService } from 'src/app/services/balance.service';
import { PrintDispatchComponent } from '../print-dispatch/print-dispatch.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-detail-payment',
  templateUrl: './detail-payment.component.html',
  styleUrls: ['./detail-payment.component.scss'],
})
export class DetailPaymentComponent implements OnInit {
  @Input() formMethod: any[] = [];
  @Input() typeUser: string = '';
  @Input() set userInfo(value) {
    if (value) {
      console.log('value :>> ', value);
      if (value.products) {
        value.products.map((item) => {
          if (item.productId) item.type = 'product';
          else if (item.serviceId) item.type = 'service';
          else if (item.subscriptionId) {
            item.type = 'inscription';
            this.showDispatch = false;
          }
        });
      }
      if (value.products && value.products.length) {
        value.products.map((product) => {
          if (product.productOption && product.productOption.length) {
            product.additionalPrice = product.productOption.reduce(
              (acc, option) => {
                if (option.price) {
                  return acc + option.price;
                }
                return acc;
              },
              0
            );
          }
          return product;
        });
        value.products = value.products.map((product) => {
          product.multiOptions = product.multiOptions.map((multiOption) => {
            multiOption.products = product.productOption.filter(
              (product) => product.multiOptionId === multiOption.id
            );
            return multiOption;
          });
          return product;
        });
      }

      this.user = value;
      this.setType();
      this.calcTax();
    }
  }
  @Input() title: any;
  @Output() close = new EventEmitter();

  public taxOrden = 0;
  public taxPayment = 0;
  public originalPrice = 0;
  public orderTax = 0;
  public paymentTax = 0;
  public paymentAmount = 0;
  public methodsTax = 0;
  public typeOrden = '';
  public user = undefined;
  public total = 0;
  public showDispatch = true;

  constructor(
    private httpSv: HttpService,
    private formSv: FormServices,
    private uiSv: UiServices,
    private translateSv: TranslateService,
    public modalController: ModalController,
    public balanceSv: BalanceService,
    private viewContainerRef: ViewContainerRef,
    private datePipe: DatePipe
  ) {}

  async ngOnInit() {}

  calcTax() {
    let payment = undefined;
    if (this.title === 'Pagos') {
      payment = this.user;
      this.paymentAmount = payment.amount;
      this.taxOrden = payment?.orden?.tax || 0;
      this.taxPayment = payment?.tax || 0;
    } else {
      payment = this.user?.payment && this.user?.payment[0];
      const methodsTax = payment?.methodsTax || 0;
      this.paymentAmount = (payment?.amount || this.user.amount) - methodsTax;
      if (payment) {
        payment.deliveryAmount = this.user?.deliveryAmount || 0;
        this.taxOrden = this.user.tax || 0;
        this.taxPayment = payment.tax || 0;
      }
    }
    if (payment?.amount) {
      if (this.title === 'Pagos') {
        this.originalPrice = payment.orden.amount;
      } else {
        this.methodsTax = payment.methodsTax || 0;
        this.originalPrice =
          ((((payment.amount -
            (payment.deliveryAmount || 0) -
            this.methodsTax) /
            (100 + this.taxPayment)) *
            100) /
            (100 + this.taxOrden)) *
          100;
      }
    } else {
      this.originalPrice = this.user.amount - this.user.deliveryAmount;
    }
    if (this.title === 'Pagos') {
      this.orderTax = payment.methodsTax;
    } else {
      this.orderTax = (this.originalPrice / 100) * this.taxOrden;
    }
    this.paymentTax =
      ((this.originalPrice + this.orderTax) / 100) * this.taxPayment;
  }

  async setType() {
    try {
      const typeOrdenUser = this.user.type;
      if (this.formMethod) {
        const typeOrden = this.formMethod.find(
          (form) => form.type === typeOrdenUser
        )?.name;
        this.typeOrden = typeOrden || typeOrdenUser;
      }
    } catch (err) {
      console.error(err);
    }
  }

  closeModal() {
    this.close.emit();
  }

  async action(type) {
    try {
      if (
        !this.user.payment?.length &&
        !this.user.inscriptionId &&
        this.title !== 'Pagos' &&
        type !== 'destroy'
      ) {
        const translate = this.translateSv.instant('EN_ESPERA_DE_PAGO');
        return this.uiSv.showToast(translate);
      } else if (type === 'destroy') {
        const msg = this.translateSv.instant(
          'ESTAS_SEGURO_QUE_DESEAS_ELIMINAR_LA_ORDEN'
        );
        const { role } = await this.uiSv.presentAlert(msg);
        if (role !== 'accept') {
          return false;
        }
      }
      const body: any = {
        id: this.user.id,
        unsave: this.typeUser === 'register' ? '' : 'true',
      };
      this.title === 'Pagos' && (body.type = 'payment');

      if (this.user.type === 'Consumo' && type === 'decline') {
        const { data } = await this.uiSv.showModal(
          DeclineReasonComponent,
          {},
          '',
          false
        );
        if (!data) {
          return;
        }
        body.declineReason = data;
      }
      await this.uiSv.showLoading();
      const res: any = await this.httpSv.itemAction(
        body,
        this.title === 'Pedido' ? 'order/admin' : 'payment/admin',
        type
      );
      if (res.status || res.state) {
        if (type !== 'destroy') {
          if (this.title === 'Pedido') {
            const { isPayment, isDeclined, isDelivered } = res.data;
            this.user.isPayment = isPayment;
            this.user.isDeclined = isDeclined;
            this.user.isDelivered = isDelivered;
          } else {
            const { isPayment } = res.payment;
            this.user.isPayment = isPayment;
          }
        } else {
          this.close.emit();
        }
        this.formSv.deleteListProductSrc.next('reloadListProduct');
      }
      await this.uiSv.loading.dismiss();
    } catch (err) {
      console.error(err);
      if (type === 'destroy') {
        let error: string = err.error?.data;
        if (error) {
          error = error.toUpperCase().replace(/ /g, '_');
          const msg = this.translateSv.instant(error);
          this.uiSv.presentAlert(msg);
        }
      }
      await this.uiSv.loading.dismiss();
    }
  }

  async print() {
    // await this.uiSv.showModal(
    //   PrintDispatchComponent,
    //   {
    //     userInfo: this.user,
    //     formMethod: this.formMethod,
    //     title: this.title,
    //   },
    //   'print-dispatch'
    // );
    const component = this.viewContainerRef.createComponent(
      PrintDispatchComponent
    );
    component.setInput('user', this.user);
    component.setInput('formMethod', this.formMethod);
    component.setInput('title', this.title);
    component.setInput('paymentAmount', this.paymentAmount);
    component.setInput('paymentTax', this.paymentTax);
    component.setInput('typeOrden', this.typeOrden);
    component.setInput('orderTax', this.orderTax);
    component.setInput('taxOrden', this.taxOrden);
    component.setInput('originalPrice', this.originalPrice);
    component.setInput('taxPayment', this.taxPayment);
    component.setInput('balanceSv', this.balanceSv);
    component.setInput('showDispatch', this.showDispatch);
    component.setInput('methodsTax', this.methodsTax);
    component.setInput('currencyBaseName', this.balanceSv.currencyBaseName);
    component.setInput(
      'createdAt',
      this.datePipe.transform(this.user.created_at, 'longDate')
    );
    if (this.user?.date) {
      component.setInput(
        'deliveryDate',
        this.datePipe.transform(this.user?.date, 'medium')
      );
    }

    setTimeout(() => {
      const printSection = window.open('', '', 'width=800,height=800');
      const style = document.createElement('style');
      style.innerHTML = `
      @media print {

        body, html, #print-section{
          height: 100% !important;
          width: 100% !important;
          display: inline-block;
          overflow: visible;
          background-color: #fff;
        }
      }
      
      body {
        background-color: #fff;
        color: #272727;
        font-family: monospace;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      .containerInfo{
        padding: 0rem;
      }
      
      .product-item{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #272727;
        align-items: center;
        height: 121.7px
      }

      .decoratedText{
        background-color: #f2f2f2;
        border-radius: 8px;
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
        padding: 0.3rem;
        margin-bottom: 1rem;
      }

      .decoratedText h5{
        margin: 10px;
      }

      .container_data_payment{
        display: grid;
        grid-template-columns: repeat(2, .5fr);
        gap: 2rem;
      }

      .boldText{
        font-weight: bold;
      }
      
      .container_quantity_price{
        display: flex;
        align-items: center;
        gap: 2rem;
      }

      .quantity{
        border: 1px solid #272727;
        border-radius: 5px;
        padding: 0.5rem 1rem;
        background-color: #f9f9f9;
      }

      .total-amount{
        display: flex;
        gap: 1rem;
        justify-content: space-between;
      }

      #amounts{
        margin: 1rem 0;
        display: flex;
        justify-content: flex-end;
      }

      .wrapper-product{
        display: flex;
        border-bottom: 1px solid #ccc;
      }

      .wrapper-product .nombre-producto{
        flex: 1
      }

      .wrapper-product .nombre-producto.info{
        text-align: right;
      }

      .amounts{
        margin-top: 0.5rem;
        display: flex;
        justify-content: flex-end;
        gap: 1.5rem;
      }
      `;
      printSection.document.body.appendChild(style);
      printSection.document.body.appendChild(component.location.nativeElement);
      setTimeout(() => {
        printSection.document.close();
        printSection.focus();
        printSection.print();
        printSection.close();
      }, 500);
    });
  }
}
